import { render } from "./PortfolioProjetosAuditor.vue?vue&type=template&id=79bd4da4"
import script from "./PortfolioProjetosAuditor.vue?vue&type=script&lang=js"
export * from "./PortfolioProjetosAuditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__